// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-setting.page.view.title': 'Team Member Settings',
    'team-member-setting.page.update.title': 'Update Settings',

    'team-member-setting.button.cancel': 'Cancel',
    'team-member-setting.button.edit': 'Edit',
    'team-member-setting.button.save': 'Save Changes',

    'team-member-setting.success.message.team_member_settings_updated': 'Your team member settings have been updated',

    'team-member-setting.error.message.error_loading_page': 'Sorry, there was an error loading team member settings.',
};
